import { useEffect, useState } from "react";
import { fetchWidgets, Widget } from "../../Helper/CustomWidgetsClient";
import { useSessionStore } from "../../Stores/Session";
import ContentRenderer from "../ContentRenderer/ContentRenderer";
import InlineHtml from "../InlineHtml/InlineHtml";
import "./CustomHomeWidgets.scss";

function CustomHomeWidgets() {
  const session = useSessionStore((s) => s.session);
  const [widgets, setWidgets] = useState<Widget[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!session?.gleapId) return;
    let cancelled = false;
    fetchWidgets()
      .then((data) => {
        if (!cancelled) {
          setWidgets(data);
          setLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setWidgets([]);
          setLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [session?.gleapId]);

  if (!loaded || widgets.length === 0) return null;

  return (
    <>
      {widgets.map((widget) => (
        <div className="widget-app-container" key={widget.id}>
          <div className="widget-app-container-body">
            <div className="custom-home-widget">
              {widget.title && (
                <div className="custom-home-widget-title">{widget.title}</div>
              )}
              {widget.html ? (
                <InlineHtml
                  html={widget.html}
                  className="custom-home-widget-body"
                />
              ) : (
                <ContentRenderer items={widget.content ?? []} />
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default CustomHomeWidgets;
